<template>
    <div class="test">
        <button v-on:click="add">Add</button>
        <button v-on:click="remove">Remove</button>
        <transition-group name="list-complete">
                <span
                    v-for="item in items"
                    v-bind:key="item"
                    class="meter-item list-complete-item"
                >
                  {{ item }}
                </span>
        </transition-group>
    </div>
</template>

<script>
    export default {
        name: 'Test',

        components: {},

        data ()
        {
            return {
                isShow: true,
                show: true,
                data: [
                    {
                        id: 1,
                        show: true,
                        title: 'Ant Design Title 1',
                    },
                    {
                        id: 2,
                        show: false,
                        title: 'Ant Design Title 2',
                    },
                    {
                        id: 3,
                        show: true,
                        title: 'Ant Design Title 3',
                    },
                    {
                        id: 4,
                        show: false,
                        title: 'Ant Design Title 4',
                    },
                ],

                items: [1, 2, 3, 4, 5],
                nextNum: 6
            }
        },

        computed: {},

        watch: {},

        mounted: function ()
        {
            const self = this;



            // setInterval(() => {
            //
            //     let num = Math.floor(Math.random() * 3);
            //     if(num == 0)
            //     {
            //         self.add();
            //     }
            //     else if(num == 1)
            //     {
            //         self.remove();
            //     }
            //     else
            //     {
            //         self.remove();
            //         self.add();
            //     }
            // }, 2000)

        },

        methods: {
            randomIndex: function ()
            {
                return Math.floor(Math.random() * this.items.length)
            },
            add: function ()
            {
                this.items.splice(this.randomIndex(), 0, this.nextNum++)
            },
            remove: function ()
            {
                this.items.splice(this.randomIndex(), 1)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .test {
        .meter-item {
            background: #cccccc;
            width: 200px;
            margin: 0 auto;
            height: 100px;
            line-height: 100px;
            color: white;
            margin-top: 10px;
        }

        .list-complete-item {
            transition: all 2s;
            display: block;
        }
        .list-complete-enter, .list-complete-leave-to {
            opacity: 0;
            transform: translateX(30px);
        }
        .list-complete-leave-active {
            position: absolute;
            transition: all 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }
        .list-complete-enter-active {
            transition: all 4s ease;
        }

        /*
        .list-complete-item {
            transition: all 1s;
            display: block;
            background: #cccccc;
            width: 200px;
            margin: 0 auto;
            height: 100px;
            line-height: 100px;
            color: white;
            margin-top: 10px;
        }

        .list-complete-enter, .list-complete-enter-to, .list-complete-leave, .list-complete-leave-to {
            opacity: 0;
            transform: translateX(30px);
            transition: all 3s ease;
        }

        .list-complete-leave-active {
            transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }

        .list-complete-enter-active {
            transition: all 1s ease;
        }
         */
    }
</style>
